import { reduce } from "et3-type-guards";
import React from "react";
import { useLocation } from "react-router-dom";
import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getMyCSRMistakesStore from "../../../stores/csr-store/csr-mistakes";
import MyCSRMistakeForm from "./my-csr-mistake-form";
import MyCSRMistakesTable from "./my-csr-mistakes-data";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";

const MyCSRMistakes = withLiteObserverAndTheme(() => {
  const location = useLocation();

  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("CSR_MY_MISTAKES", "CSR_MY_MISTAKES");
    getMyCSRMistakesStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("MY_CSR_MISTAKES")}
        subTitle={i18n.get("MY_CSR_MISTAKES")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <MyCSRMistakeForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <MyCSRMistakesTable />
    </ET3PageDiv>
  );
});
export default MyCSRMistakes;
